import { memo, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import useAddData from "../../../../Hooks/Portal/useAddData";
import useUpdateData from "../../../../Hooks/Portal/useUpdateData";

const validationSchema = yup.object({
    oldPassword: yup.string().required("Current password is required"),
    newPassword: yup.string().required("New password is required").min(8, "Password must be at least 8 characters"),
    confirmPassword: yup.string().required("Confirm new password is required").oneOf([yup.ref("newPassword"), null], "Passwords must match"),
});


function ChangePassword() {

    const { update, loading, errorMessage, error } = useUpdateData()

    const [ showPassword, setShowPassword ] = useState(false)
    
    const initialValues = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    };

 

    const handleSubmit = (values, { resetForm }) => {
        update("changePassword", values)
        resetForm();
    };
    
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6 mt-5">
          <h4 className="text-center mb-4">Change Password</h4>
         
          {errorMessage && !error &&  (
            <div className="alert alert-danger" role="alert">
                <b className="mb-3">Check the following errors!</b>
                {errorMessage?.oldPassword && <li className="mt-3">{errorMessage?.oldPassword}</li>}
                {errorMessage?.newPassword && <li className="mt-3">{errorMessage?.newPassword}</li>}
                {errorMessage?.confirmPassword && <li className="mt-3">{errorMessage?.confirmPassword}</li>}
            </div>
          )}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form>
                <div className="form-group mb-3">
                  <label htmlFor="oldPassword">Current Password</label>
                  <Field
                    type="password"
                    name="oldPassword"
                    className={`form-control ${
                      formik.touched.oldPassword &&
                      formik.errors.oldPassword
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="Enter your current password"
                    />
                    <span className="invalid-feedback"><ErrorMessage name="oldPassword"></ErrorMessage></span>
                  {/* <ErrorMessage
                    name="oldPassword"
                    component="div"
                    className="invalid-feedback"
                  /> */}
                </div>
                
                 <div className="form-group mb-3">
                  <label htmlFor="newPassword">New Password</label>
                  <div className="input-group">
                    <Field
                      type={showPassword ? "text" : "password"}
                      name="newPassword"
                      className={`form-control ${
                        formik.touched.newPassword && formik.errors.newPassword
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter your new password"
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary rounded-end"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <VscEyeClosed/> : <VscEye/>}
                    </button>
                  <span className="invalid-feedback"><ErrorMessage name="newPassword"></ErrorMessage></span>
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="confirmPassword">
                    Confirm New Password
                  </label>
                  <div className="input-group">
                    <Field
                      type={showPassword ? "text" : "password"}
                      name="confirmPassword"
                      className={`form-control ${
                        formik.touched.confirmPassword &&
                        formik.errors.confirmPassword
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Confirm your new password"
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary rounded-end"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <VscEyeClosed/> : <VscEye/>}
                    </button>
                    <ErrorMessage
                        name="confirmPassword"
                        component="div"
                        className="invalid-feedback"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn portal--btn btn-block"
                  disabled={!formik.isValid || formik.isSubmitting}
                >
                  {formik.isSubmitting && loading ? "changing..." : "Change"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default memo(ChangePassword);